import React, { Fragment, useState } from "react";
import { mutate } from "swr";

import { Action } from "../../../types/Action";
import { ApiResponse } from "../../../types/API/ApiResponse";

import QueryComponent from "../../QueryComponent/QueryComponent";
import SkeletonTable from "../../Skeletons/SkeletonTable";
import Card from "../../common/Card/Card";
import Typography from "../../common/Typography/Typography";
import ActionPreviewItem from "../../Action/ActionPreviewItem/ActionPreviewItem";
import Modal from "../../common/Modals/Modal/Modal";
import ActionView from "../../Action/ActionView/ActionView";

type QueryComponentPropTypes = React.ComponentProps<typeof QueryComponent>;

interface Props {
    title: string;
    cacheKey: QueryComponentPropTypes["cacheKey"];
    service: () => Promise<ApiResponse<"actions", Action[]>>;
}

const DashboardActionsList = ({ title, cacheKey, service }: Props) => {
    // Logic to open and close the actions modal.
    const [actionToView, setActionToView] = useState<Action["ID"] | null>(null);
    const handleOpenModal = (actionId: Action["ID"]) => setActionToView(actionId);
    const handleCloseModal = () => setActionToView(null);

    const handleActionStatusChange = () => {
        mutate(cacheKey);
    };

    return (
        <Fragment>
            <QueryComponent
                cacheKey={cacheKey}
                service={service}
                showLoadingOnValidating
                loadingFallback={<SkeletonTable rows={5} columns={1} />}
            >
                {({ data }) => (
                    <Card className="space-y-1 flex flex-col">
                        <Typography as="h3" variant="smallCaps">
                            {title}
                        </Typography>
                        <div className="flex flex-col gap-0.5">
                            {data?.actions.map((action) => (
                                <ActionPreviewItem key={action.Findings} action={action} className="grow" onClick={handleOpenModal} />
                            ))}
                        </div>
                    </Card>
                )}
            </QueryComponent>
            <Modal show={!!actionToView} onClose={handleCloseModal} full childClassName="p-1">
                <ActionView actionId={actionToView!} onClose={handleCloseModal} onActionStatusChange={handleActionStatusChange} />
            </Modal>
        </Fragment>
    );
};

export default DashboardActionsList;
